<template>
	<section>
		<header-simple :title="$t('labels.profile.social_numbers')" :subtitle="$t('Personal information about the patient.')">
			<!-- <action-button @click="addContact" :title="$t('Add contact')" /> -->
		</header-simple>
	</section>
</template>

<script>
import HeaderSimple from '@/modules/ui/HeaderSimple'
export default {
	name: 'watch-profile-s-s-numbers',
	components: {
		HeaderSimple
	},
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/watch/profile/watchProfile/WatchProfileSSNumbers.vue